import { RSAA } from 'redux-api-middleware'
import queryString from 'query-string'

import { createChannelCP, createPlaylistCP, destroyChannelCP, destroyPlaylistCP } from './content'
import { DateUtils, EstateUtils } from '../utils'

export const ContentPushActions = {
    CONTENT_PUSH_REQUEST: 'CONTENT_PUSH##REQUEST',
    CONTENT_PUSH_SUCCESS: 'CONTENT_PUSH##SUCCESS',
    CONTENT_PUSH_CREATE_SUCCESS: 'CONTENT_PUSH_CREATE##SUCCESS',
    CONTENT_PUSH_EDIT_SUCCESS: 'CONTENT_PUSH_EDIT##SUCCESS',
    CONTENT_PUSH_SHOW_SUCCESS: 'CONTENT_PUSH_SHOW##SUCCESS',
    FETCH_CONTENT_PUSHES_STATUS_REQUEST: 'CONTENT_PUSH_STATUS##REQUEST',
    FETCH_CONTENT_PUSHES_STATUS_SUCCESS: 'CONTENT_PUSH_STATUS##SUCCESS',
    FETCH_CONTENT_PUSHES_LEVEL_REQUIRED_REQUEST: 'CONTENT_PUSH_LEVEL_REQUIRED##REQUEST',
    FETCH_CONTENT_PUSHES_LEVEL_REQUIRED_SUCCESS: 'CONTENT_PUSH_LEVEL_REQUIRED##SUCCESS',
    FETCH_CONTENT_PUSHES_GROUP_REQUEST: 'CONTENT_PUSH_GROUP##REQUEST',
    FETCH_CONTENT_PUSHES_GROUP_SUCCESS: 'CONTENT_PUSH_GROUP##SUCCESS',
    CHANGE_CONTENT_PUSH_FILTERS: 'CHANGE_CONTENT_PUSH_FILTERS',
    API_CALL_FAILURE: 'API_CALL##FAILURE',
}

/**
 * Fetch content pushes
 * @param {string} estate estate id
 */
export const searchContentPush = ({ search = '', statusList = [], groupList = [], levelList = [], notGroupList = [] }) => {
    let statusListAsString = null
    let groupListAsString = null
    let levelListAsString = null
    let notGroupListAsString = null
    if (statusList && statusList.length > 0) statusListAsString = statusList.join()
    if (groupList && groupList.length > 0) groupListAsString = groupList.join()
    if (levelList && levelList.length > 0) levelListAsString = levelList.join()
    if (notGroupList && notGroupList.length > 0) notGroupListAsString = notGroupList.join()

    const toQueryString = {
        name: search,
        status: statusListAsString,
        group: groupListAsString,
        level: levelListAsString,
        notGroups: notGroupListAsString,
    }
    const query = queryString.stringify(toQueryString, {
        skipNull: true,
    })

    return (dispatch, getState) => {
        const state = getState()
        const api = EstateUtils.getAPI(state)
        return dispatch({
            [RSAA]: {
                endpoint: `${api}/content_pushes?${query}`,
                method: 'GET',
                types: [ContentPushActions.CONTENT_PUSH_REQUEST, ContentPushActions.CONTENT_PUSH_SUCCESS, ContentPushActions.API_CALL_FAILURE],
            },
        })
    }
}

/**
 * Create new content push item.
 * @param {Object} cp
 */
export const createContentPush = (cp) => async (dispatch, getState) => {
    if (!cp) {
        return null
    }

    const api = EstateUtils.getAPI(getState())

    // Content push data to send
    const body = {
        ...cp,
        date_end: DateUtils.formatDB(cp.date_end),
        date_start: DateUtils.formatDB(cp.date_start),
        level_required: cp.level_required && cp.level_required.id ? cp.level_required.id : cp.level_required,
        group: cp.group && cp.group.id ? cp.group.id : cp.group,
        status: cp.purchase_order ? '3' : '5',
    }

    // Send store petition to api
    return dispatch({
        [RSAA]: {
            endpoint: `${api}/content_pushes`,
            method: 'POST',
            types: [ContentPushActions.CONTENT_PUSH_REQUEST, ContentPushActions.CONTENT_PUSH_CREATE_SUCCESS, ContentPushActions.API_CALL_FAILURE],
            body: JSON.stringify(body),
        },
    })
}

/**
 * Edit existing content push
 * @param {Object} cp
 */
export const editContentPush = (cp, hadPO) => {
    if (!cp) {
        return null
    }

    const { id } = cp
    const { status: cpStatus } = cp
    let status = cpStatus
    if (!hadPO) status = cp.purchase_order ? '3' : '5'
    const body = {
        ...cp,
        date_end: DateUtils.formatDB(cp.date_end),
        date_start: DateUtils.formatDB(cp.date_start),
        level_required: cp.level_required && cp.level_required.id ? cp.level_required.id : cp.level_required,
        group: cp.group && cp.group.id ? cp.group.id : cp.group,
        status: status && status.id ? status.id : status,
    }

    return (dispatch, getState) => {
        const state = getState()
        const api = EstateUtils.getAPI(state)
        return dispatch({
            [RSAA]: {
                endpoint: `${api}/content_pushes/${id}`,
                method: 'PUT',
                types: [ContentPushActions.CONTENT_PUSH_REQUEST, ContentPushActions.CONTENT_PUSH_EDIT_SUCCESS, ContentPushActions.API_CALL_FAILURE],
                body: JSON.stringify(body),
            },
        })
    }
}

/**
 * Fetch cp item information
 * @param {string} estate estate id
 * @param {number} id content push id
 */
export const showContentPush = (id) => {
    return (dispatch, getState) => {
        const state = getState()
        const api = EstateUtils.getAPI(state)
        return dispatch({
            [RSAA]: {
                endpoint: `${api}/content_pushes/${id}`,
                method: 'GET',
                types: [ContentPushActions.CONTENT_PUSH_REQUEST, ContentPushActions.CONTENT_PUSH_SHOW_SUCCESS, ContentPushActions.API_CALL_FAILURE],
            },
        })
    }
}

/**
 * Fetch content pushes possible status
 */
export const fetchContentPushesStatus = () => {
    return (dispatch, getState) => {
        const state = getState()
        const api = EstateUtils.getAPI(state)
        return dispatch({
            [RSAA]: {
                endpoint: `${api}/content_pushes_status`,
                method: 'GET',
                types: [
                    ContentPushActions.FETCH_CONTENT_PUSHES_STATUS_REQUEST,
                    ContentPushActions.FETCH_CONTENT_PUSHES_STATUS_SUCCESS,
                    ContentPushActions.API_CALL_FAILURE,
                ],
            },
        })
    }
}

/**
 * Fetch content pushes possible groups
 */
export const fetchContentPushesGroup = () => {
    return (dispatch, getState) => {
        const state = getState()
        const api = EstateUtils.getAPI(state)
        return dispatch({
            [RSAA]: {
                endpoint: `${api}/content_pushes_group`,
                method: 'GET',
                types: [
                    ContentPushActions.FETCH_CONTENT_PUSHES_GROUP_REQUEST,
                    ContentPushActions.FETCH_CONTENT_PUSHES_GROUP_SUCCESS,
                    ContentPushActions.API_CALL_FAILURE,
                ],
            },
        })
    }
}

/**
 * Fetch content pushes possible levels
 */
export const fetchContentPushesLevelRequired = () => {
    return (dispatch, getState) => {
        const state = getState()
        const api = EstateUtils.getAPI(state)
        return dispatch({
            [RSAA]: {
                endpoint: `${api}/content_pushes_level_required`,
                method: 'GET',
                types: [
                    ContentPushActions.FETCH_CONTENT_PUSHES_LEVEL_REQUIRED_REQUEST,
                    ContentPushActions.FETCH_CONTENT_PUSHES_LEVEL_REQUIRED_SUCCESS,
                    ContentPushActions.API_CALL_FAILURE,
                ],
            },
        })
    }
}

export const changeContentPushFilters = (status, groups, levels) => ({
    type: ContentPushActions.CHANGE_CONTENT_PUSH_FILTERS,
    payload: { status, groups, levels },
})

export const editFormField = (name, value) => ({
    type: 'CONTENT_PUSH_FORM_EDIT',
    payload: { name, value },
})

export const clearForm = () => ({
    type: 'CONTENT_PUSH_FORM_CLEAR',
})

export const resetForm = () => async (dispatch) => {
    // Clear old channel and playlist if existing
    await dispatch(destroyChannelCP())
    await dispatch(destroyPlaylistCP())

    // Create a new channel and playlist for the new content push request
    await dispatch(createChannelCP())
    await dispatch(createPlaylistCP())

    // Clear form data
    return dispatch(clearForm())
}
